module.exports = __webpack_public_path__ + "img/typhoon.a3676823.svg";